import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import React, { useMemo } from 'react';
import '../widgets/InfluencerTable/index.scss';

interface ICurrentGameIcon {
  gameInfo: any;
  beforeIcon?: React.ReactNode;
  afterIcon?: React.ReactNode;
  style?: React.CSSProperties;
}
const CurrentGameIcon = (props: ICurrentGameIcon) => {
  const {
    gameInfo,
    beforeIcon,
    afterIcon,
    style = { width: 14, height: 14 , borderRadius : 3},
  } = props;
  return (
    <div className="dbo-current-game-icon">
      {beforeIcon}
      <RenderGameIcon gameInfo={gameInfo} imgStyle={style}></RenderGameIcon>
      {afterIcon}
    </div>
  );
};

export default CurrentGameIcon;
